import React, { ReactNode } from 'react'

import { ErrorList } from '../error-list'
import { InputContainer } from '../input-container'
import { InputHelp } from '../input-help'
import { Label } from '../label/label'

let _idCounter = 0
const generateId = () => `base-input-${++_idCounter}`

interface BaseInputProps {
  component: ReactNode
  help?: ReactNode | ReactNode[] | string
  touched?: boolean
  errors?: ReactNode[]
  id?: string
  label?: ReactNode
  showToggle?: ReactNode
  submitFailed?: boolean
  componentStyle?: 'one' | 'two'
  margin?: number
  dataTestId?: string
}

export const BaseInput: React.FC<BaseInputProps> = ({
  component,
  errors = [],
  help,
  id = generateId(),
  label,
  showToggle = null,
  touched,
  submitFailed,
  componentStyle = 'one',
  margin,
  dataTestId = 'input-field',
}) => (
  <InputContainer margin={margin}>
    <Label
      text={label}
      showToggle={showToggle}
      htmlFor={id}
      variant={componentStyle}
      dataTestId={`${dataTestId}-label`}
    />
    {component}
    <ErrorList
      inputId={id}
      submitFailed={submitFailed}
      touched={touched}
      errors={errors}
      dataTestId={`${dataTestId}-error`}
    />
    <InputHelp id={id} help={help} />
  </InputContainer>
)

export default BaseInput
